import { Flex, Skeleton, Typography } from "antd"
import { useTranslation } from "react-i18next"

import styles from "./styles.module.less"

const { Text, Title } = Typography

export const KpiCardsGrid = ({ cards, loading }) => {
  const { t } = useTranslation()

  return (
    <Flex gap={24} className={styles.grid}>
      {loading
        ? Array.from({ length: cards.length }, (_, i) => (
            <Flex key={i} vertical gap={8} justify="center" className={styles.card}>
              <Skeleton.Node active className={styles.skeletonLabel} />
              <Skeleton.Node active className={styles.skeletonValue} />
              <Skeleton.Node active className={styles.skeletonSubtitle} />
            </Flex>
          ))
        : cards.map((c) => (
            <Flex
              key={c.key}
              vertical
              gap={1}
              align="start"
              justify="center"
              className={styles.card}
              data-testid={`deflect-user-kpi-${c.key}`}
            >
              <Text
                ellipsis={{ tooltip: t(c?.label) }}
                type="secondary"
                strong
                className={styles.label}
                style={{ fontSize: 14, lineHeight: "20px" }}
              >
                {t(c.label)}
              </Text>
              <Title
                ellipsis={{ tooltip: c.value }}
                level={3}
                className={styles.value}
                style={{
                  margin: 0,
                  fontSize: 24,
                  // Inter glyphs at 24px are ~29px tall: a shorter line overflows vertically and antd's
                  // ellipsis check reports every value as truncated, so the tooltip always shows.
                  lineHeight: "30px",
                  fontWeight: 600,
                  width: "100%",
                  textAlign: "start"
                }}
              >
                {c.value}
              </Title>
              <Text type="secondary" style={{ fontSize: 12, lineHeight: "16px" }}>
                {t(c.subtitle)}
              </Text>
            </Flex>
          ))}
    </Flex>
  )
}
